<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import { searchPosts } from "@/fetch";
import MonthButtons from "@/components/MonthButtons.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const itemStore = useItemStore();

let timer = 0;

const checkEnter = (e: KeyboardEvent) => {
  // Prevent submit on enter.
  return e.key !== "Enter";
};

const changeSearch = (e: KeyboardEvent) => {
  clearTimeout(timer);
  if (e.key === "Enter") {
    // Search right away on Enter.
    doSearch();
  } else {
    // Delayed search on other buttons.
    timer = setTimeout(() => {
      doSearch();
    }, 700);
  }
};

const doSearch = () => {
  if (itemStore.search.length > 0) {
    itemStore.resetShow();
    searchPosts();
  }
};

const getClass = () => {
  let className = "btn sort";
  if (itemStore.settings.sortBy) {
    className += itemStore.settings.asc ? " asc" : " desc";
  }
  return className;
};
</script>

<template>
  <div class="filter-elements">
    <div class="search-container" v-if="itemStore.settings.showSearch">
      <input
        type="search"
        :placeholder="t('search')"
        v-model="itemStore.search"
        @keyup="changeSearch"
        @keydown="checkEnter"
      />
    </div>
    <button :class="getClass()" @click="itemStore.toggleSort()" v-if="itemStore.settings.showSort">
      ABC
    </button>
    <MonthButtons v-if="itemStore.settings.showMonth" />
  </div>
</template>
